import { useModal, create } from '@ebay/nice-modal-react';
import { useMemo } from 'react';

import { LoyaltyIdQrCodeScanActionSheetController } from './loyalty-id-qr-code-scan-action-sheet.controller';

const LoyaltyIdQrCodeScanActionSheetModal = create(LoyaltyIdQrCodeScanActionSheetController);

export const useLoyaltyIdQrCodeScanActionSheet = () => {
  const { show, hide } = useModal(LoyaltyIdQrCodeScanActionSheetModal);
  return useMemo(() => ({ open: show, close: hide }), [hide, show]);
};
